import { EnumCorridorColor } from "../enum/enum-corridor-color";
import { ServiceLine } from "./service-line";

export class QuoteWrapper {
    public serviceLines: ServiceLine[];
    public nonNegociableArticleColor?: string;
    public readonly color?: EnumCorridorColor;
    public readonly existingColor?: EnumCorridorColor;
}
